import { render } from "./LearningProgressBar.vue?vue&type=template&id=4e5697c7"
import script from "./LearningProgressBar.vue?vue&type=script&lang=js"
export * from "./LearningProgressBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__